import React from 'react'
import {
  CreditPayment,
  BoletoPayment,
  PixPayment,
  PagalevePayment,
  TwoCardsPayment,
  CardPixPayment,
  CardBoletoPayment
} from './index'

interface PaymentFinishProps {
  selectedMethod: string
  cartItems: any[]
  shippingAddress?: any
}

export const PaymentFinish: React.FC<PaymentFinishProps> = ({ selectedMethod, cartItems, shippingAddress }) => {
  const renderPaymentComponent = () => {
    switch (selectedMethod) {
      case 'credit':
        return <CreditPayment selectedMethod={selectedMethod} cartItems={cartItems} shippingAddress={shippingAddress} />
      case 'boleto':
        return <BoletoPayment selectedMethod={selectedMethod} cartItems={cartItems} />
      case 'pix':
        return <PixPayment selectedMethod={selectedMethod} cartItems={cartItems} />
      case 'pagaleve':
        return <PagalevePayment selectedMethod={selectedMethod} cartItems={cartItems} />
      case 'two_cards':
        return (
          <TwoCardsPayment selectedMethod={selectedMethod} cartItems={cartItems} shippingAddress={shippingAddress} />
        )
      case 'card_pix':
        return (
          <CardPixPayment selectedMethod={selectedMethod} cartItems={cartItems} shippingAddress={shippingAddress} />
        )
      case 'card_boleto':
        return (
          <CardBoletoPayment selectedMethod={selectedMethod} cartItems={cartItems} shippingAddress={shippingAddress} />
        )
      default:
        return (
          <div className="h-fit w-full rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
            <div className="space-y-6">
              <div className="text-center">
                <h2 className="mb-4 text-2xl font-bold text-gray-800">Método de pagamento não reconhecido</h2>
                <p className="mb-6 text-gray-600">
                  Valor recebido:{' '}
                  <span className="rounded bg-gray-100 px-2 py-1 font-mono">{selectedMethod || 'undefined'}</span>
                </p>
                <p className="text-sm text-gray-500">
                  Métodos válidos: credit, boleto, pix, pagaleve, two_cards, card_pix, card_boleto
                </p>
              </div>
            </div>
          </div>
        )
    }
  }

  return renderPaymentComponent()
}
